import dayjs from 'dayjs';
import $http from '@/utils/ajax';

export const TYPE_LIST = [
    '规章制度',
    '担保/典当合同',
    '融资/借贷合同',
    '合并/兼并/转制/重组',
    '代理合同',
    '采购/收购/订/定购合同',
    '认证/见证/公证文书',
    '委托/托管/信托合同',
    '教育文化合同',
    '劳动/人事/用工合同',
    '挂靠合同',
    '转让出让合同',
    '组织/组建/组团合同',
    '承揽/加工/制造/生产合同',
    '承包合同',
    '群体性合同/公约/章程',
    '婚姻家庭类合同',
    '出资/投资/合伙/合作合同',
    '安装/施工/装饰合同',
    '运输/物流合同',
    '其他'
];

// 0-1小数转百分比
export const percentFormat = num => {
    return Math.floor(num * 100).toFixed(0) + '%';
};

// 时间格式化
export const dateFormat = val => {
    if (!val) {
        return '-';
    }
    return dayjs(val).format('YYYY年MM月DD日 HH:mm');
};

/**
 * 获取合同列表
 * @param {*} status 0为生成中，1为成功，2为失败
 */
export const getContractList = status => {
    return $http
        .get('/bp/api/aicontract/list', {
            params: {
                status
            }
        })
        .then(res => {
            if (+res?.code === 0 && res?.data?.list) {
                return Promise.resolve(res.data.list);
            }
            return Promise.reject(res);
        });
};

/**
 * 获取合同详情
 * @param {*} id
 */
export const getContractInfo = id => {
    return $http
        .get('/bp/api/aicontract/info', {
            params: {
                contract_id: id
            }
        })
        .then(res => {
            if (+res?.code === 0 && res?.data?.id) {
                return Promise.resolve(res.data);
            }
            return Promise.reject(res);
        });
};

/**
 * 获取合同文档下载链接
 * @param {Object} contract
 */
export const getContractDocLink = contract => {
    const {id, bos_link} = contract;
    if (bos_link) {
        return Promise.resolve(bos_link);
    }
    // 无下载链接时，请求下载链接
    return $http
        .post('/bp/api/aicontract/download', {
            data: {
                contract_id: id
            }
        })
        .then(res => {
            if (res?.data?.bos_link) {
                const bosLink = res.data.bos_link;
                return Promise.resolve(bosLink);
            }
            return Promise.reject(res?.msg);
        });

};

/**
 * 检查是否有未读的合同
 * @param {*} id 最新的合同id
 */
export const checkLatestUnread = id => {
    const lastReadId = localStorage.getItem('lastReadContractId');
    return id && +lastReadId !== +id;
};
